// Configuração do EmailJS
// Para usar este serviço:
// 1. Acesse https://emailjs.com e crie uma conta
// 2. Crie um novo serviço de email (ex: Gmail, Outlook, etc.)
// 3. Crie um template de email
// 4. Substitua as chaves abaixo pelas suas chaves reais

export const EMAILJS_CONFIG = {
    SERVICE_ID: 'service_yh2desa', // SERVICE_ID que funcionou no teste
    TEMPLATE_ID: 'template_xhn3t6s', // Template ID correto
    PUBLIC_KEY: '3wkxxkNaFWUl8fr42', // Public Key correto
};